const initialState = {
    loaded: false
}

const apiClientReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CLIENT_LOADED':
            return {
                ...state,
                loaded: action.loaded
            }
        default:
            return state
    }
}

export default apiClientReducer


// WEBPACK FOOTER //
// ./src/common/ApiClient/ApiClientReducer.jsx